import { useState } from "react";
import VimeoLink from "./VimeoLink";
import { FormControlLabel, Stack, Switch } from "@mui/material";
import VimeoUpload from "./VimeoUpload";

export default function VimeoField(props) {
    const [isLink, setLink] = useState(true);

    const handleSwitch = (e) => setLink(!e.target.checked);

    const handleUpload = (vimeoVideo) => {
        props.onChange(vimeoVideo?.id ?? null);
    } 

    return (
        <Stack gap={1}>
            {isLink && <VimeoLink {...props} />}
            <FormControlLabel 
                control={<Switch checked={!isLink} onChange={handleSwitch} />} 
                label="Uploader la vidéo"
            />
            {!isLink && <VimeoUpload id={props.sectionId} onChange={handleUpload} />}
        </Stack>
    );
}